import { USER_MANAGEMENT_DEFAULTS as D } from '../UserManagement.constants'

export type Assignment = {
    customerId: string
    customerLabel: string
    roleId: string
    roleLabel: string
    productIds: string[]
    productLabels: string[]
}

export function getCustomerLabel(customerId: string, customerLabel: string, isLoggedInAsUserManager: boolean): string {
    if (!isLoggedInAsUserManager) return customerLabel
    return (/nosla/i.test(customerId) || /nosla/i.test(customerLabel)) ? D.LABEL_NO_SLA_DISPLAY : D.LABEL_EMPTY_VALUE
}

export function isNoSlaCustomer(customerId: string): boolean {
    return /^nosla$/i.test(customerId)
}

export function findLabel(options: ReadonlyArray<{ value: string; label: string }>, value: string, fallback: string): string {
    return options.find(o => o.value === value)?.label ?? fallback
}

export function getSubmitLabel(submitting: boolean, submitLabel: string, fallbackLabel: string): string {
    if (submitting) return D.BTN_SAVING
    return submitLabel || fallbackLabel
}
